import React, { useState, useEffect } from 'react';

const EditarCadastroPage = ({ onNavigate }) => {
    const [formData, setFormData] = useState({
        nome: '',
        cnpj: '',
        telefone: '',
        email: '',
        cep: '',
        rua: '',
        numero: '',
        complemento: '',
        bairro: '',
        cidade: '',
        estado: ''
    });
    
    const [senhaData, setSenhaData] = useState({
        senhaAtual: '',
        novaSenha: '',
        confirmarSenha: ''
    });
    
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [mostrarSenha, setMostrarSenha] = useState(false);
    
    const restauranteId = localStorage.getItem('restauranteId');
    const API_BASE_URL = 'http://localhost:3000';
    
    useEffect(() => {
        carregarDados();
    }, []);

    const carregarDados = async () => {
        if (!restauranteId) {
            setError('Sessão expirada. Faça login novamente.');
            setTimeout(() => onNavigate('Login'), 2000);
            return;
        }
        
        try {
            setLoading(true);
            const response = await fetch(`${API_BASE_URL}/restaurantes/${restauranteId}`);

            if (response.ok) {
                const data = await response.json();
                setFormData({
                    nome: data.nome || '',
                    cnpj: data.cnpj || '',
                    telefone: data.telefone || '',
                    email: data.email || '',
                    cep: data.cep || '',
                    rua: data.rua || data.logradouro || '',
                    numero: data.numero || '',
                    complemento: data.complemento || '',
                    bairro: data.bairro || '',
                    cidade: data.cidade || '',
                    estado: data.estado || ''
                });
                setError('');
            } else {
                setError('Erro ao carregar dados. Tente novamente.');
            }
        } catch (error) {
            console.error('Erro ao carregar dados:', error);
            setError('Erro de conexão com o servidor');
        } finally {
            setLoading(false);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSenhaChange = (e) => {
        const { name, value } = e.target;
        setSenhaData(prev => ({ ...prev, [name]: value }));
    };

    const handleCepChange = async (e) => {
        const cep = e.target.value.replace(/\D/g, '');
        setFormData(prev => ({ ...prev, cep }));

        if (cep.length === 8) {
            try {
                const response = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
                if (response.ok) {
                    const data = await response.json();
                    if (!data.erro) {
                        setFormData(prev => ({
                            ...prev,
                            rua: data.logradouro || '',
                            bairro: data.bairro || '',
                            cidade: data.localidade || '',
                            estado: data.uf || ''
                        }));
                    }
                }
            } catch (error) {
                console.error('Erro ao buscar CEP:', error);
            }
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess('');

        // Validações básicas
        if (!formData.nome || !formData.email) {
            setError('Nome e email são obrigatórios');
            return;
        }

        const cnpjLimpo = formData.cnpj.replace(/\D/g, '');
        if (cnpjLimpo.length !== 14) {
            setError('CNPJ deve ter 14 dígitos');
            return;
        }

        try {
            const dadosParaEnviar = {
                ...formData,
                cnpj: cnpjLimpo,
                telefone: formData.telefone.replace(/\D/g, ''),
                cep: formData.cep.replace(/\D/g, '')
            };

            const response = await fetch(`${API_BASE_URL}/restaurantes/${restauranteId}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(dadosParaEnviar),
            });

            if (response.ok) {
                const data = await response.json();
                setSuccess('Dados atualizados com sucesso!');
                
                // Atualizar nome no localStorage se mudou
                if (formData.nome) {
                    localStorage.setItem('userName', formData.nome);
                }
                
                setTimeout(() => {
                    onNavigate('Perfil', formData.nome);
                }, 1500);
            } else {
                const errorData = await response.json();
                setError(errorData.error || 'Erro ao atualizar dados');
            }
        } catch (error) {
            console.error('Erro ao atualizar:', error);
            setError('Erro de conexão com o servidor');
        }
    };

    const handleSenhaSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess('');

        if (!senhaData.senhaAtual || !senhaData.novaSenha || !senhaData.confirmarSenha) {
            setError('Preencha todos os campos de senha');
            return;
        }

        if (senhaData.novaSenha.length < 6) {
            setError('Nova senha deve ter no mínimo 6 caracteres');
            return;
        }

        if (senhaData.novaSenha !== senhaData.confirmarSenha) {
            setError('Nova senha e confirmação não coincidem');
            return;
        }

        try {
            // Primeiro verificar se a senha atual está correta fazendo login
            const loginResponse = await fetch(`${API_BASE_URL}/login`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    email: formData.email,
                    senha: senhaData.senhaAtual
                }),
            });

            if (!loginResponse.ok) {
                setError('Senha atual incorreta');
                return;
            }

            // Se login OK, atualizar com nova senha
            const updateResponse = await fetch(`${API_BASE_URL}/restaurantes/${restauranteId}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    senha: senhaData.novaSenha
                }),
            });

            if (updateResponse.ok) {
                setSuccess('Senha alterada com sucesso!');
                setSenhaData({
                    senhaAtual: '',
                    novaSenha: '',
                    confirmarSenha: ''
                });
            } else {
                const errorData = await updateResponse.json();
                setError(errorData.error || 'Erro ao alterar senha');
            }
        } catch (error) {
            console.error('Erro ao alterar senha:', error);
            setError('Erro de conexão com o servidor');
        }
    };
    
    if (loading) {
        return (
            <div className="form-container">
                <p style={{textAlign: 'center', color: '#797129'}}>Carregando dados...</p>
            </div>
        );
    }
    
    return (
        <div className="form-container" style={{maxWidth: '700px'}}>
            <h2 className="page-title">Editar Cadastro</h2>
            
            {error && <div className="error-message">{error}</div>}
            {success && <div className="success-message">{success}</div>}

            {/* Formulário de Dados Cadastrais */}
            <form onSubmit={handleSubmit} style={{marginBottom: '40px'}}>
                <h3 style={{
                    color: '#797129',
                    marginBottom: '20px',
                    fontFamily: "'Miltonian Tattoo', cursive",
                    textTransform: 'uppercase'
                }}>
                    Dados do Restaurante
                </h3>

                <div className="form-group">
                    <label htmlFor="nome">Nome do Restaurante *</label>
                    <input
                        type="text"
                        id="nome"
                        name="nome"
                        className="form-input"
                        value={formData.nome}
                        onChange={handleChange}
                        required
                    />
                </div>

                <div className="form-row">
                    <div className="form-group">
                        <label htmlFor="cnpj">CNPJ *</label>
                        <input
                            type="text"
                            id="cnpj"
                            name="cnpj"
                            className="form-input"
                            value={formData.cnpj}
                            onChange={handleChange}
                            placeholder="00.000.000/0000-00"
                            maxLength="18"
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="telefone">Telefone *</label>
                        <input
                            type="tel"
                            id="telefone"
                            name="telefone"
                            className="form-input"
                            value={formData.telefone}
                            onChange={handleChange}
                            placeholder="(00) 00000-0000"
                            required
                        />
                    </div>
                </div>

                <div className="form-group">
                    <label htmlFor="email">E-mail *</label>
                    <input
                        type="email"
                        id="email"
                        name="email"
                        className="form-input"
                        value={formData.email}
                        onChange={handleChange}
                        required
                    />
                </div>

                <div className="form-row">
                    <div className="form-group" style={{flex: '0 0 30%'}}>
                        <label htmlFor="cep">CEP *</label>
                        <input
                            type="text"
                            id="cep"
                            name="cep"
                            className="form-input"
                            value={formData.cep}
                            onChange={handleCepChange}
                            placeholder="00000-000"
                            maxLength="9"
                            required
                        />
                    </div>
                    <div className="form-group" style={{flex: '1'}}>
                        <label htmlFor="rua">Rua *</label>
                        <input
                            type="text"
                            id="rua"
                            name="rua"
                            className="form-input"
                            value={formData.rua}
                            onChange={handleChange}
                            required
                        />
                    </div>
                </div>

                <div className="form-row">
                    <div className="form-group" style={{flex: '0 0 30%'}}>
                        <label htmlFor="numero">Número *</label>
                        <input
                            type="text"
                            id="numero"
                            name="numero"
                            className="form-input"
                            value={formData.numero}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="form-group" style={{flex: '1'}}>
                        <label htmlFor="complemento">Complemento</label>
                        <input
                            type="text"
                            id="complemento"
                            name="complemento"
                            className="form-input"
                            value={formData.complemento}
                            onChange={handleChange}
                        />
                    </div>
                </div>

                <div className="form-row">
                    <div className="form-group">
                        <label htmlFor="bairro">Bairro *</label>
                        <input
                            type="text"
                            id="bairro"
                            name="bairro"
                            className="form-input"
                            value={formData.bairro}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="cidade">Cidade *</label>
                        <input
                            type="text"
                            id="cidade"
                            name="cidade"
                            className="form-input"
                            value={formData.cidade}
                            onChange={handleChange}
                            required
                        />
                    </div>
                    <div className="form-group" style={{flex: '0 0 20%'}}>
                        <label htmlFor="estado">UF *</label>
                        <input
                            type="text"
                            id="estado"
                            name="estado"
                            className="form-input"
                            value={formData.estado}
                            onChange={handleChange}
                            maxLength="2"
                            required
                        />
                    </div>
                </div>

                <button type="submit" className="form-button" style={{backgroundColor: '#797129'}}>
                    💾 Salvar Alterações
                </button>
            </form>

            {/* Formulário de Alteração de Senha */}
            <div style={{
                borderTop: '2px solid #797129',
                paddingTop: '30px'
            }}>
                <h3 style={{
                    color: '#797129',
                    marginBottom: '20px',
                    fontFamily: "'Miltonian Tattoo', cursive",
                    textTransform: 'uppercase'
                }}>
                    Alterar Senha
                </h3>

                <form onSubmit={handleSenhaSubmit}>
                    <div className="form-group">
                        <label htmlFor="senhaAtual">Senha Atual *</label>
                        <input
                            type={mostrarSenha ? "text" : "password"}
                            id="senhaAtual"
                            name="senhaAtual"
                            className="form-input"
                            value={senhaData.senhaAtual}
                            onChange={handleSenhaChange}
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="novaSenha">Nova Senha * (mínimo 6 caracteres)</label>
                        <input
                            type={mostrarSenha ? "text" : "password"}
                            id="novaSenha"
                            name="novaSenha"
                            className="form-input"
                            value={senhaData.novaSenha}
                            onChange={handleSenhaChange}
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="confirmarSenha">Confirmar Nova Senha *</label>
                        <input
                            type={mostrarSenha ? "text" : "password"}
                            id="confirmarSenha"
                            name="confirmarSenha"
                            className="form-input"
                            value={senhaData.confirmarSenha}
                            onChange={handleSenhaChange}
                        />
                    </div>

                    <div style={{marginBottom: '20px'}}>
                        <label style={{display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer'}}>
                            <input
                                type="checkbox"
                                checked={mostrarSenha}
                                onChange={(e) => setMostrarSenha(e.target.checked)}
                            />
                            <span style={{fontSize: '14px', color: '#666'}}>Mostrar senhas</span>
                        </label>
                    </div>

                    <button type="submit" className="form-button" style={{backgroundColor: '#797129'}}>
                        🔒 Alterar Senha
                    </button>
                </form>
            </div>

            <div style={{marginTop: '30px', textAlign: 'center'}}>
                <button 
                    onClick={() => onNavigate('Perfil')}
                    className="form-button"
                    style={{backgroundColor: '#85200C'}}
                >
                    ← Voltar ao Perfil
                </button>
            </div>
        </div>
    );
};

export default EditarCadastroPage;